import React from 'react';
import { Menu } from '@material-ui/core';
import { gameInfos } from '@data/game.infos';
import { useGame } from '@domain/game.selection/game.selection.hook';
import { AnchorElementProps } from '@domain/types/prop.types';
import { GameListLogo } from '@components/app.chrome/game.menu.styles';
import { ListLink } from '@components/list.link';
import { RawMenuItem } from '@components/raw.menu.item';

function cancelClick(e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) {
  e.preventDefault();
}

const GameMenu = ({ anchorEl, onClearAnchor }: AnchorElementProps) => {
  const game = useGame();

  return (
    <Menu
      id='game-menu'
      anchorEl={anchorEl}
      getContentAnchorEl={null}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      keepMounted
      open={!!anchorEl}
      onClose={onClearAnchor}
      PaperProps={{ style: { width: 250 } }}
    >
      {gameInfos.map((g) => (
        <RawMenuItem key={g.urlId} onClick={onClearAnchor}>
          <ListLink to={`/${g.urlId}`} avoidPrefix onClick={g.urlId === game.urlId ? cancelClick : undefined}>
            <GameListLogo src={g.logoImgSrc} alt={g.title} />
            {g.title}
          </ListLink>
        </RawMenuItem>
      ))}
    </Menu>
  );
};

export default GameMenu;
